import React from 'react';
import {ReactComponent as Amazon} from "../../../../../../asset/icons/amazonIcon.svg";
import {ReactComponent as Calender} from "../../../../../../asset/icons/cal.svg";
import {ReactComponent as UserIcon} from "../../../../../../asset/icons/user-icon.svg";
import {ReactComponent as FeedCoin} from "../../../../../../asset/icons/three-coin-icon.svg";
import {ReactComponent as PercentIcon} from "../../../../../../asset/icons/percentIcon.svg";
import {useTranslation} from "react-i18next";
import moment from "moment-jalaali";
import {clubLevels} from "../../../../../../helperData/Data";

function CardDetail({data}) {
  const {t} = useTranslation()


  function usedDiscount() {
    if (!isNaN(+data?.discount_cards_count) && !isNaN(+data?.remain_count)) {
      return +data?.discount_cards_count - +data?.remain_count
    }
    return 0
  }

  return (
    <div className='offer-management-card-detail-container'>
      <div className='card-detail-title'>
        <div className='card-detail-logo'>
          <Amazon/>
        </div>
        <div>
          {data.name} {data?.discount_amount ? '٪' + data?.discount_amount : ''}
        </div>
      </div>
      <div className='card-detail-description'>
        {data?.description}
      </div>
      <div className='card-detail-summary card-detail-summary-date'>
        <div className='card-detail-summary-title'>
          {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.Timespan')}
        </div>
        <Calender/>
        <div className='card-detail-summary-detail'>
          {moment(data?.date_start).format("jYYYY/jMM/jDD")}
          <span>~</span> {moment(data?.date_end).format("jYYYY/jMM/jDD")}
        </div>
      </div>
      <div className='card-detail-summary'>
        <div className='card-detail-summary-title'>
          {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.NumberCard')}
        </div>
        <PercentIcon/>
        <div className='card-detail-summary-detail'>
          {data?.remain_count} {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.Number')}
        </div>
      </div>

      <div className='card-detail-table'>
        <div className='card-detail-report'>
          <div className='card-detail-report-container'>
            <div className='card-detail-report-title'>
              {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.Used')}
            </div>
            <div className='card-detail-report-number'>
              {usedDiscount()}
            </div>
          </div>
          <div className='card-detail-report-container'>
            <div className='card-detail-report-title'>
              {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.Remain')}
            </div>
            <div className='card-detail-report-number'>
              {!isNaN(+data?.remain_count) ? +data?.remain_count : 0}
            </div>
          </div>
          <div className='card-detail-report-container'>
            <div className='card-detail-report-title'>
              {t('Src.Pages.CustomerClub.Components.OfferManagment.CardDetailModal.CardDetail.Score')}
            </div>
            <div className='card-detail-report-number'>
              {data?.received_coin || 0}
            </div>
          </div>
        </div>

        <div className='card-detail-users'>
          {data?.requireds?.map((item, index) => {
            return (
              <div key={index} className='card-detail-users-item'>
                <div className='card-detail-users-item-title'>
                  {item?.target_company?.logo ?
                    <img src={item.target_company.logo} alt={item?.target_company?.name || ''}/>
                    : null}
                  <div>
                    {item?.target_company?.name}
                  </div>
                </div>
                <div className='card-detail-users-item-type'>
                  <UserIcon/>
                  <div>
                    {clubLevels.find(el => el.id === item.club_level)?.title || ''}
                  </div>
                </div>
                <div className='card-detail-users-item-feedCoin'>
                  <FeedCoin/>
                  <div>
                    {item.required_score}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}

export default CardDetail;
